<!--All Schools-->
<div class="ua-Table">
	<p-table
		#mydt
		[value]="lstFacility"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedFacilities"
		dataKey="FacilityID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--Selected-->

				<!--FacilityCD-->
				<th>
					<p-columnFilter type="text" field="FacilityCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
				<!--FacilityName-->
				<th>
					<p-columnFilter type="text" field="FacilityName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="FacilityCD">Code<p-sortIcon field="FacilityCD"></p-sortIcon></th>
				<th pSortableColumn="FacilityName">Name<p-sortIcon field="FacilityName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-facility>
			<tr [pSelectableRow]="facility">
				<td>
					<p-tableCheckbox [pSelectableRow]="facility" [value]="facility"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ facility[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="TextCenter TopMargin" style="margin-bottom: 50px">
	<button class="btn btn-primary" (click)="onUpdate()">Add</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
